import { render, staticRenderFns } from "./McpServer.vue?vue&type=template&id=142b9077&scoped=true"
import script from "./McpServer.vue?vue&type=script&lang=js"
export * from "./McpServer.vue?vue&type=script&lang=js"
import style0 from "./McpServer.vue?vue&type=style&index=0&id=142b9077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142b9077",
  null
  
)

export default component.exports